<template>
    <div class='images-container'>
        <ThumbnailsList :product='product' :images='product.images' @thumbnailClickListener='thumbnailClickListener'/>
       
        <ProductImagePlaceholders v-show='!product.product'/>
        <div id='product_image_carousel' class="glide main-product-image-size" v-show='product.product'>
            <div class="glide__track" data-glide-el="track">
                <ul class="glide__slides">
                    <div v-for='(image, index) in product.images' :key="image">
                        <li class="glide__slide"> 
                            <DynamicImageContainer class="product-image" :image='image' @click='expandImage(index)' />
                        </li>
                    </div>
                </ul>
            </div>
             <div class="glide__arrows" data-glide-el="controls">
                <button class="change-image-arrow left-arrow" data-glide-dir="<"><i class="fa-solid fa-chevron-left"></i></button>
                <button class="change-image-arrow right-arrow" data-glide-dir=">"><i class="fa-solid fa-chevron-right"></i></button>
            </div>
             <div class="glide__bullets" data-glide-el="controls[nav]">
                 <template v-for='(image, index) in product.images' :key="image">
                    <button class="glide__bullet" :data-glide-dir="'='+index"></button>
                 </template>
            </div>
        </div>
    </div>
</template>

<script>
import "@glidejs/glide/dist/css/glide.core.css";
import "@glidejs/glide/dist/css/glide.theme.css";
import ThumbnailsList from '@/ecom/components/products/single_product/images/ThumbnailsList.vue';
import Glide from '@glidejs/glide'
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import ProductImagePlaceholders from '@/ecom/components/products/single_product/images/ProductImagePlaceholders.vue';

export default {
    components: {ThumbnailsList, DynamicImageContainer, ProductImagePlaceholders},
    props: ['product'],
    data(){
        return{
            images: [],
            glide_instance: null
        }
    },
    methods:{
        expandImage(index){
            let thumbnails = document.getElementsByClassName('thumbnail');
            
            let data_source = [];

            for (let i = 0; i < thumbnails.length; i++) {
                let item = {
                    // src: require(`@/ecom/assets/images/${this.product.images[i]}`),
                    src: `/images/${this.product.images[i]}`,
                    width: document.getElementsByClassName('thumbnail')[i].naturalWidth, //get actual size of images before any crop applied
                    height: document.getElementsByClassName('thumbnail')[i].naturalHeight,
                    alt: this.product.images[i]
               }

               data_source.push(item);
            }

            const options = {
                dataSource: data_source,
                pswpModule: () => import('photoswipe'),
            };

            const lightbox = new PhotoSwipeLightbox(options);
            lightbox.init();

            lightbox.loadAndOpen(index); // defines start slide index
  
        },
        goToImage(index){
            this.glide_instance.update({
                startAt: index
            })
        },
        thumbnailClickListener(image){
            this.goToImage(this.product.images.indexOf(image));
        }
    },
    watch:{
        'product': function(){
            setTimeout(() => {
                if(document.getElementById('product_image_carousel') != null){
                    this.glide_instance = new Glide('#product_image_carousel',{type: 'carousel',  dragThreshold: false}).mount();
                }
            }, 1);
        }
    }
    
}
</script>

<style lang="scss" scoped>
.glide__arrows{
    position: absolute;
    top: 40%;
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-left: 15px;
    padding-right: 15px;

    @media(max-width: 768px){
        padding-left: 0px;
        padding-right: 0px;
        // margin-left: -10px;
    }
}

.right-arrow{
    @media(max-width: 768px){
        margin-right: -20px;
    }
}

.left-arrow{
    @media(max-width: 768px){
        margin-left: -20px;
    }
}

:deep(){ //deep allow access into child component (<MainImage/>)
    .main-product-image-size{ 
        width: 800px;

        @media(max-width: 1860px){
            width: 675px;
        }

        @media(max-width: 1580px){
            width: 600px;
        }
            
        @media (max-width: 1150px) {
            width: 400px;
        }

        @media(max-width: 970px){
            width: 90vw;
        }

        @container(max-width: 970px){
            width: 100px;
        }
    }
}
.product-image{
    object-fit: cover;
    object-position: 50% 0;

    width: 800px;

    @media(max-width: 1860px){
        width: 675px;
    }

    @media(max-width: 1580px){
        width: 600px;
    }
        
    @media (max-width: 1150px) {
        width: 400px;
    }

    @media(max-width: 970px){
        width: 90vw;
    }
}

.images-container{
    display: flex;
    gap: 20px;
    flex-wrap: wrap;
}

.change-image-arrow{
    border: none;
    background-color: transparent;
    font-size: 2rem;
    cursor: pointer;
    color: #343a40;
}

.glide * {
    cursor: pointer;
}
</style>